import React from "react"
import {Editable, EditableElementProps} from "../HorizontalField/EditableHorizontalField"
import {useAccessToken} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {getAccountWalletTerms} from "../../resources/account"

export interface EditableWalletTermsProps {
	walletTerms: string
	setWalletTerms: (value: string) => void
	accountId: string
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: string) => void
}

export function EditableWalletTermsField(props: EditableWalletTermsProps) {
	return (
		<Editable
			label="Wallet Terms"
			isEditing={props.isEditing}
			isDisabled={props.isDisabled}
			isAllowed={props.isAllowed}
			onStartEdit={props.onStartEdit}
			onCancel={props.onCancel}
			setValue={props.setWalletTerms}
			value={props.walletTerms}
			initial={props.walletTerms}
			update={props.update}
			accountId={props.accountId}
		>
			{EditableWalletTerms}
		</Editable>
	)
}

export function EditableWalletTerms(props: EditableElementProps<string>) {
	const accessToken = useAccessToken()
	const result = useAsyncResult(() => getAccountWalletTerms(accessToken, props.accountId))

	if (props.isEditing) {
		return result.match(
			() => <></>,
			(walletTerms) => (
				<div className="select is-small">
					<select value={props.value} onChange={(e) => props.setValue(e.target.value)}>
						{walletTerms.data.map((dp) => (
							<option key={dp.attributes.name} value={dp.attributes.name}>
								{dp.attributes.name}
							</option>
						))}
					</select>
				</div>
			),
			(_) => <>Error</>
		)
	} else {
		return <input type="text" readOnly value={props.value} className="input is-static" />
	}
}
